export enum Stage {
  deeplink = 'DEEPLINK',
  selection = 'SELECTION',
  review = 'REVIEW',
  processing = 'PROCESSING',
  confirmation = 'CONFIRMATION',
  error = 'ERROR',
}
